import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import Shell from "@/components/Shell";
import Auth from "@/pages/Auth";
import Onboarding from "@/pages/Onboarding";
import Home from "@/pages/Home";
import Ask from "@/pages/Ask";
import Learn from "@/pages/Learn";
import Skills from "@/pages/Skills";
import Practice from "@/pages/Practice";
import Tools from "@/pages/Tools";
import Ideas from "@/pages/Ideas";
import Safety from "@/pages/Safety";
import Multiverse from "@/pages/Multiverse";
import Profile from "@/pages/Profile";
import Career from "@/pages/Career";
import ReadThis from "@/pages/ReadThis";
import Family from "@/pages/Family";
import Nutrition from "@/pages/Nutrition";
import { Infinity as InfinityIcon } from "lucide-react";

function Splash() {
  return (
    <div className="min-h-screen grid place-items-center bg-background">
      <div className="flex flex-col items-center gap-3 animate-pulse">
        <div className="h-12 w-12 rounded-2xl bg-primary grid place-items-center text-primary-foreground"><InfinityIcon className="w-7 h-7" /></div>
        <span className="font-head font-bold text-muted-foreground">Loading inizio…</span>
      </div>
    </div>
  );
}

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <Splash />;
  if (!user) return <Navigate to="/auth" replace />;
  if (!user.onboarded) return <Navigate to="/onboarding" replace />;
  return <Shell>{children}</Shell>;
}

export default function App() {
  const { user, loading } = useAuth();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/auth" element={loading ? <Splash /> : user ? <Navigate to="/" replace /> : <Auth />} />
        <Route path="/onboarding" element={loading ? <Splash /> : !user ? <Navigate to="/auth" replace /> : <Onboarding />} />
        <Route path="/" element={<Protected><Home /></Protected>} />
        <Route path="/ask" element={<Protected><Ask /></Protected>} />
        <Route path="/learn" element={<Protected><Learn /></Protected>} />
        <Route path="/skills" element={<Protected><Skills /></Protected>} />
        <Route path="/practice" element={<Protected><Practice /></Protected>} />
        <Route path="/career" element={<Protected><Career /></Protected>} />
        <Route path="/read" element={<Protected><ReadThis /></Protected>} />
        <Route path="/nutrition" element={<Protected><Nutrition /></Protected>} />
        <Route path="/family" element={<Protected><Family /></Protected>} />
        <Route path="/tools" element={<Protected><Tools /></Protected>} />
        <Route path="/ideas" element={<Protected><Ideas /></Protected>} />
        <Route path="/safety" element={<Protected><Safety /></Protected>} />
        <Route path="/multiverse" element={<Protected><Multiverse /></Protected>} />
        <Route path="/profile" element={<Protected><Profile /></Protected>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
